/* !
 * jQuery prodFavo v1.0.0
 * Copyright 2021, Connecty Inc.
 */
(function ($, SANGETSU, cssua) {
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const slideSpeed = 'fast';
	let WOSURL = 'https://wos.sangetsu.co.jp/biz_user/sample_cart_in.php?in_hinban=';
	let guideFlg = false;

	// カットサンプル請求 除外対象品番
	const cutSampleExclusionList = [
		'30805105', '30805515', '30805761', '31105225', '31105326', '31105327', '30705105', '30705515', '30705761', '31005225', '31005326', '31005327', '45050101', '45050679', '45050105', '45050210', '45050506', '45250101', '45250679', '45250105', '45250210', '45250506', '30401100', '30401105', '30401585', '30401505', '30201100', '30201105', '30201585', '30201505', '30301100', '30301105', '30301585', '30301505', '30101100', '30101105', '30101585', '30101505', '37571761', '37571585', '37571500', '37571375', '37571225', '37571411', '37371105', '37371760', '37371505', '37371555', '37471761', '37471585', '37471500', '37471375', '37471225', '37471411', '48787675', '48987100', '48987675', '48987510', '48987327', '48887100', '48887675', '48887510', '48887327', '13633111', '13633518', '13633496'
	];

	///////////////////////////////////////// test /////////////////////////////////////////
	// $('.js-mainLoader').removeClass('is-loading');
	// $('.favorite-wrap').addClass(v);
	///////////////////////////////////////// test /////////////////////////////////////////

	// テストデータ
	// const favoriteList = [
	// 	{
	// 		pn: 'SGA174',
	// 		pndisp: 'SGA174',
	// 		cat: '壁紙',
	// 		img: 'https://contents.sangetsu.co.jp/img/chip/ET406_20150904C01.jpg',
	// 		datetime: '2021-05-20 10:30:30',
	// 		sample: '0',
	// 		download: ["test.zip", "test2.zip"],
	// 		check: false
	// 	},
	// 	{
	// 		pn: 'SGA175',
	// 		pndisp: 'SGA175',
	// 		cat: '椅子生地',
	// 		img: 'https://contents.sangetsu.co.jp/img/chip/ET406_20150904C01.jpg',
	// 		datetime: '2021-05-21 12:00:00',
	// 		sample: '1',
	// 		download: ["test2.zip"],
	// 		check: false
	// 	}
	// ];

	// GAイベント送信
	const GAsendEventCutSample = () => {
		gtag('event', 'favorite click', {
			'event_category': 'favorite click',
			'event_action': 'cutSample',
			'event_label': 'https://www.sangetsu.co.jp/favorite/',
		});
	};
	const GAsendEventDownload = () => {
		gtag('event', 'favorite click', {
			'event_category': 'favorite click',
			'event_action': 'download',
			'event_label': 'https://www.sangetsu.co.jp/favorite/',
		});
	};

	// ご利用ガイド
	const setGuide = () => {
		let $modal = $('.mod-modal'),
			$overlay = $('.mod-modal-overlay'),
			$open = $('.__guide'),
			$close = $('.__close');

		const modalResize = () => {
			var w = $(window).width();
			var h = $(window).height();
			var cw = $modal.outerWidth();

			if (SANGETSU.va.window.width <= 400) {
				$modal.css({
					'height': (h - 200) + 'px',
					'left': ((w - cw) / 2) + 'px'
				});
			} else {
				$modal.css({
					'height': (h - 100) + 'px',
					'left': ((w - cw) / 2) + 'px'
				});
			}
		};
		const openModal = () => {
			modalResize();
			$overlay.addClass(v).fadeIn(slideSpeed);
			$modal.fadeIn(slideSpeed);
		};

		$open.on('click', () => {
			openModal();
		});

		$overlay.on('click', () => {
			$modal.fadeOut(slideSpeed);
			$overlay.fadeOut(slideSpeed);
		});
		$close.on('click', () => {
			$modal.fadeOut(slideSpeed);
			$overlay.fadeOut(slideSpeed);
		});

		// 初期表示
		if (!guideFlg) {
			if (!localStorage.getItem('favoriteGuide')) {
				openModal();
			} else {
				$('.mod-modal .mod-check-input').prop('checked', true);
			}
			guideFlg = true;
		}

		// 次回から表示しない
		$('.mod-modal .mod-check-input').on('click', (e) => {
			if ($(e.currentTarget).prop('checked')) {
				localStorage.setItem('favoriteGuide', 'true');
			} else {
				localStorage.removeItem('favoriteGuide');
			}
		});
	};

	// チップ画像群の読み込み完了後に開ける
	const imgLoad = () => {
		let promiseImgLoad = new Promise((resolve) => {
			let count = 0;

			$('.__prodImg').each((idx, ele) => {
				let prodImg = new Image();
				prodImg.onload = () => {
					count++;
					if (count === $('.__prodImg').length) {
						return resolve('Success');
					}
				};
				prodImg.onerror = () => {
					count++;
					if (count === $('.__listImg').length) {
						return resolve('Success');
					}
				}
				prodImg.src = $(ele).find('img').attr('src');
			});
		});
		Promise.all([promiseImgLoad]).then(() => {
			// ロードを外す
			$('.js-mainLoader').removeClass('is-loading');
			$('.favorite-wrap').addClass(v);
			setGuide();
		});
	};

	// カットサンプル請求
	const setCutSampleURL = (_itemList) => {
		const SAMPLE_NUM = 50; // 一度に50件以上は請求不可
		let checkCnt = 0, checkSampleFlg = true, param = '';
		for (let i = 0; i < _itemList.length; i++) {
			if (_itemList[i].check) {
				param += _itemList[i].pn + '.';
				checkCnt++;
				if (_itemList[i].sample === '0') { // sample_cut_flag === '0' なら請求不可
					checkSampleFlg = false;
				}
			}
		}
		if (checkSampleFlg && checkCnt <= SAMPLE_NUM && checkCnt > 0) {
			param = param.slice(0, -1);
			// console.log(WOSURL + param);

			window.open(WOSURL + param, 'order_win');
			GAsendEventCutSample(); // GA送信

			$('.favorite-submitSampleText').addClass(a);
			setTimeout(() => { $('.favorite-submitSampleText').addClass(v); }, 100);
			setTimeout(() => {
				$('.favorite-submitSampleText').removeClass(v);
				setTimeout(() => { $('.favorite-submitSampleText').removeClass(a); }, 100);
			}, 3000);

			return true;
		} else {
			if (!checkSampleFlg) {
				$('.favorite-float .__btn._cutSample ._sampleFlg').addClass(a);
			}
			if (checkCnt > SAMPLE_NUM) {
				$('.favorite-float .__btn._cutSample ._checkCnt').addClass(a);
			}
			if (checkCnt === 0) {
				$('.favorite-float .__btn._cutSample ._noCheck').addClass(a);
			}
			$('.favorite-float .__btn._cutSample .__caution').addClass(a);
			setTimeout(() => { $('.favorite-float .__btn._cutSample .__caution').addClass(v); }, 100);
			setTimeout(() => {
				$('.favorite-float .__btn._cutSample .__caution').removeClass(v);
				setTimeout(() => { $('.favorite-float .__btn._cutSample .__caution').removeClass(a); }, 100);
			}, 3000);

			return false;
		}
	};

	// 画像ダウンロード
	const setDownloadZIP = (_itemList) => {
		const CONTENTS_URL = 'https://contents.sangetsu.co.jp/zip/item-zip/';
		let zipURLList = [];
		for (let i = 0; i < _itemList.length; i++) {
			if (_itemList[i].check) {
				let downloadList = _itemList[i].download;
				for (let j = 0; j < downloadList.length; j++) {
					zipURLList.push(CONTENTS_URL + downloadList[j]);
				}
			}
		}
		if (zipURLList.length) {
			// ボタンを押下不可にする
			$('.favorite-float .__btn._download').addClass('is-standby');

			const promises = zipURLList.map(
				(src, i) => new Promise((resolve, reject) => {
					let xhr = new XMLHttpRequest();
					xhr.open('GET', src, true);
					xhr.responseType = 'blob';
					xhr.onload = function () {
						const fileName = src.slice(src.lastIndexOf('/') + 1);
						resolve({ data: this.response, fileName: fileName });
					};
					xhr.onerror = () => resolve({ data: null });
					xhr.onabort = () => resolve({ data: null });
					xhr.ontimeout = () => resolve({ data: null });
					xhr.send();
				})
			);
			Promise.all(promises).then((AllFiles) => {
				// すべてのファイルが取得できたらzipを生成
				const FOLDER_NAME = 'sangetsu_download';
				let zip = new JSZip();
				let folder = zip.folder(FOLDER_NAME);

				AllFiles.forEach((file) => {
					if (file.data && file.fileName) {
						folder.file(file.fileName, file.data);
					}
				});
				zip.generateAsync({ type: 'blob' }).then((_blob) => {
					// hiddenのボタンを作ってダウンロード発火
					let btn = document.createElement('a');
					btn.href = URL.createObjectURL(_blob);
					btn.download = FOLDER_NAME + '.zip';
					btn.style.display = 'none';
					document.body.appendChild(btn);
					btn.click();
					document.body.removeChild(btn);

					$('.favorite-float .__btn._download').removeClass('is-standby');

				});
				GAsendEventDownload(); // GA送信
			});
		} else {
			$('.favorite-float .__btn._download ._noCheck').addClass(a);
			$('.favorite-float .__btn._download .__caution').addClass(a);
			setTimeout(() => { $('.favorite-float .__btn._download .__caution').addClass(v); }, 100);
			setTimeout(() => {
				$('.favorite-float .__btn._download .__caution').removeClass(v);
				setTimeout(() => { $('.favorite-float .__btn._download .__caution').removeClass(a); }, 100);
			}, 3000);
		}
	};

	// お気に入り一覧
	const setFavoList = () => {
		// localStorageから抽出
		let favoriteStorage = [];
		for (let i in localStorage) {
			if (i.indexOf('favoriteList-') !== -1) {
				favoriteStorage.push(i);
			}
		}
		if (favoriteStorage.length) {
			// 出力用配列生成
			let favoriteList = [];
			let p = new Promise((resolve) => {
				let count = 0;

				$.each(favoriteStorage, (idx, ele) => {
					let favoriteProd = ele.replace(/favoriteList-/, '');
					let favoriteImg, favoriteCat, cutsampleFlg, favoritePnDisp;
					$.when($.getJSON('/ajax/product/file_url/chip_pict/' + favoriteProd, (JSONdata) => {
						// console.log('/ajax/product/file_url/chip_pict/' + favoriteProd);
						if (JSONdata.product_list.length && JSONdata.product_list[0].url_list.output.length) {
							favoriteImg = JSONdata.product_list[0].url_list.output[0].url;
						} else {
							favoriteImg = '/temp_noimage.jpg';
						}
					}), $.getJSON('/ajax/product/category/' + favoriteProd, (JSONdata) => {
						// console.log('/ajax/product/category/' + favoriteProd);
						if (JSONdata.product_list.length) {
							// カテゴリ名
							let groupCode = JSONdata.product_list[0].item_group.code;
							let prodCat = JSONdata.product_list[0].product_category1.code;
							if (groupCode !== '04' && groupCode !== '06') {
								switch (groupCode) {
									case '01': favoriteCat = '壁紙'; break;
									case '02': favoriteCat = '粘着剤付化粧フィルム（リアテック）'; break;
									case '03': favoriteCat = 'ガラスフィルム'; break;
									case '05': favoriteCat = '椅子生地'; break;
									case '07': favoriteCat = 'カーペットタイル'; break;
									case '08': favoriteCat = 'フロア'; break;
									case '09': favoriteCat = 'フロアタイル'; break;
									case '12': favoriteCat = 'その他'; break;
									default: break;
								}
							} else if (groupCode === '04') {
								if (prodCat === '119') {
									favoriteCat = 'ロールスクリーン・ブラインド';
								} else {
									favoriteCat = 'カーテン';
								}
							} else if (groupCode === '06') {
								if (prodCat === '135') {
									favoriteCat = 'ラグ';
								} else {
									favoriteCat = 'カーペット';
								}
							}

							favoritePnDisp = JSONdata.product_list[0].part_no_disp;
							cutsampleFlg = (cutSampleExclusionList.some(ele => favoriteProd === ele)) ? '0' : JSONdata.product_list[0].sample_cut_flag;
							downloadFiles = JSONdata.product_list[0].download_pict_zip;
						}
					})).done(() => {
						if (favoriteCat) {
							favoriteList.push({
								datetime:
									`${localStorage[ele].split('/')[0]}/${('00' + localStorage[ele].split('/')[1]).slice(-2)}/${('00' + localStorage[ele].split('/')[2].split(' ')[0]).slice(-2)}` +
									` ${localStorage[ele].split(' ')[1]}`,
								pn: favoriteProd,
								pndisp: favoritePnDisp,
								img: favoriteImg,
								cat: favoriteCat,
								sample: cutsampleFlg,
								download: downloadFiles,
								check: false,
							});
							++count;
							if (count === favoriteStorage.length) {
								return resolve(favoriteList);
							}
						} else {
							// 無効なアイテムはlocalStorageから削除
							localStorage.removeItem('favoriteList-' + favoriteProd);
							++count;
						}
					}).fail(() => {
						localStorage.removeItem('favoriteList-' + favoriteProd);
						++count;
					});
				});
			});
			Promise.all([p]).then(() => {
				favoriteList.sort((x, y) => {
					let xDate = x['datetime'];
					let yDate = y['datetime'];
					if (xDate > yDate) return -1;
					if (xDate < yDate) return 1;
					return 0;
				});

				// Vueで描画
				if (favoriteList.length) {
					let sortKey = 'datetime';
					let sortType = 'DESC';

					// localStorageにソート記録があれば反映
					if (localStorage.getItem('favoriteSortKey')) {
						sortKey = localStorage.getItem('favoriteSortKey');
						sortType = localStorage.getItem('favoriteSortType');
						if (sortType === 'DESC') {
							$(`svg._desc[data-target="${sortKey}"]`).addClass(a);
							$(`svg._asc[data-target="${sortKey}"]`).removeClass(a);
						} else {
							$(`svg._asc[data-target="${sortKey}"]`).addClass(a);
							$(`svg._desc[data-target="${sortKey}"]`).removeClass(a);
						}
					}

					let vue = new Vue({
						el: '#vue-items',
						data: {
							list: favoriteList,
							num: favoriteList.length,
							sortKey: sortKey,
							sortType: sortType,
							checkCnt: 0
						},
						methods: {
							getChecked(_check) {
								if (_check) {
									return 'checked';
								} else {
									return false;
								}
							},
							setCheckEvent(_item) {
								if (_item.check) {
									_item.check = false;
									this.checkCnt--;
								} else {
									_item.check = true;
									this.checkCnt++;
								}
							},
							setAllCheck() {
								for (let i in this.list) {
									this.list[i].check = true;
								}
								this.checkCnt = this.list.length;
							},
							setAllClear() {
								for (let i in this.list) {
									this.list[i].check = false;
								}
								this.checkCnt = 0;
							},
							setSample(_sample) {
								return ((_sample === '1') ? '○' : '×');
							},
							setDate(_datetime) {
								return `${_datetime.slice(0, 4)}/${_datetime.slice(5, 7).replace(/^0+/, '')}/${_datetime.slice(8, 10).replace(/^0+/, '')}`;
							},
							setProdURL(_pn) {
								return `/product/detail/${_pn}/`;
							},
							sortASCBy(_key) {
								$('.favorite-wrap').removeClass(v);
								$('.js-mainLoader').addClass('is-loading');
								setTimeout(() => {
									this.sortKey = _key;
									this.sortType = 'ASC';
									imgLoad();
								}, 100);
								localStorage.setItem('favoriteSortKey', _key);
								localStorage.setItem('favoriteSortType', 'ASC');
							},
							sortDESCBy(_key) {
								$('.favorite-wrap').removeClass(v);
								$('.js-mainLoader').addClass('is-loading');
								setTimeout(() => {
									this.sortKey = _key;
									this.sortType = 'DESC';
									imgLoad();
								}, 100);
								localStorage.setItem('favoriteSortKey', _key);
								localStorage.setItem('favoriteSortType', 'DESC');
							},
							removeItem(_item) {
								let idx = this.list.indexOf(_item);
								this.list.splice(idx, 1);
								localStorage.removeItem(`favoriteList-${_item.pn}`);
								localStorage.setItem('favoriteCount', this.list.length);
								$('.js-favoCnt').text(this.list.length);
							},
							setCutSample() {
								let success = setCutSampleURL(this.list);
								if (success) { // AllClear
									for (let i in this.list) {
										this.list[i].check = false;
									}
									this.checkCnt = 0;
								}
							},
							setDownload() {
								setDownloadZIP(this.list);
							}
						},
						computed: {
							sortedItems() {
								if (this.sortKey !== '') {
									if (this.sortType === 'ASC') {
										this.list.sort((a, b) => {
											if (a[this.sortKey] < b[this.sortKey]) return -1;
											if (a[this.sortKey] > b[this.sortKey]) return 1;
											return 0;
										});
									} else {
										this.list.sort((a, b) => {
											if (a[this.sortKey] > b[this.sortKey]) return -1;
											if (a[this.sortKey] < b[this.sortKey]) return 1;
											return 0;
										});
									}
									return this.list;
								} else {
									return this.list;
								}
							}
						}
					});

					// ソート用ボタン切り替え
					$('._desc').on('click', (e) => {
						$(e.currentTarget).removeClass(a);
						$(e.currentTarget).next('._asc').addClass(a);
					});
					$('._asc').on('click', (e) => {
						$(e.currentTarget).removeClass(a);
						$(e.currentTarget).prev('._desc').addClass(a);
					});

					// SPソート項目切り替え
					if (!cssua.ua.desktop) {
						$('.__select .__head').on('click', (e) => {
							$(e.currentTarget).toggleClass(a);
							$(e.currentTarget).next('.__body').stop().slideToggle();
						});
						$('.__select .__body li').on('click', (e) => {
							let sort = $(e.currentTarget).attr('data-label');
							$('.__spSort .__sortBtn').each((idx, ele) => { $(ele).removeClass(a); });
							$(`.__spSort .__sortBtn[data-label="${sort}"]`).addClass(a);
							$('.__select .__head span').text($(e.currentTarget).text());
							$('.__select .__body').stop().slideUp();
						});

					}
				}
				// 件数を反映
				localStorage.setItem('favoriteCount', favoriteList.length);
				$('.js-favoCnt').text(favoriteList.length);

				imgLoad();
			});
		} else {
			// 0件表示
			$('.js-mainLoader').removeClass('is-loading');
			$('.is-emply').removeClass('di_none');
		}
	};

	// スクロールでヘッダー追従
	const favoHeadFixed = () => {
		let pos;
		if (SANGETSU.va.window.width > 1024) {
			pos = 140;
		} else if (SANGETSU.va.window.width <= 1024 && SANGETSU.va.window.width > 767) {
			pos = 180;
		} else {
			pos = 120;
		}
		$(window).scroll(() => {
			if ($(window).scrollTop() > pos) {
				$('.favorite-head').addClass(f);
			} else {
				$('.favorite-head').removeClass(f);
			}
		});
	};


	setFavoList();
	favoHeadFixed();


})(window.jQuery, window.SANGETSU, window.cssua);
